import {
  DELETE_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH,
  DELETE_ORGANIZATION_PLOT_GROUPS_PATH,
  DELETE_ORGANIZATION_ROADMAP_NODES_PATH,
  DeleteOrganizationPlotGroupComparisonsErrorDto,
  DeleteOrganizationPlotGroupComparisonsRequestPathVariables,
  DeleteOrganizationPlotGroupComparisonsRequestQueryParams,
  DeleteOrganizationPlotGroupComparisonsSuccessDto,
  DeleteOrganizationPlotGroupsErrorDto,
  DeleteOrganizationPlotGroupsRequestPathVariables,
  DeleteOrganizationPlotGroupsRequestQueryParams,
  DeleteOrganizationPlotGroupsSuccessDto,
  DeleteOrganizationRoadmapNodesErrorDto,
  DeleteOrganizationRoadmapNodesRequestPathVariables,
  DeleteOrganizationRoadmapNodesRequestQueryParams,
  DeleteOrganizationRoadmapNodesSuccessDto,
  PATCH_ORGANIZATION_PATH,
  PATCH_ORGANIZATION_PLOT_GROUPS_PATH,
  PATCH_ORGANIZATION_SUMMARY_PATH,
  PatchOrganizationErrorDto,
  PatchOrganizationPlotGroupsErrorDto,
  PatchOrganizationPlotGroupsRequestBody,
  PatchOrganizationPlotGroupsRequestPathVariables,
  PatchOrganizationPlotGroupsRequestQueryParams,
  PatchOrganizationPlotGroupsSuccessDto,
  PatchOrganizationRequestBodyData,
  PatchOrganizationRequestPathVariables,
  PatchOrganizationRequestQueryParams,
  PatchOrganizationSuccessDto,
  PatchOrganizationSummaryErrorDto,
  PatchOrganizationSummaryRequestBodyData,
  PatchOrganizationSummaryRequestPathVariables,
  PatchOrganizationSummaryRequestQueryParams,
  PatchOrganizationSummarySuccessDto,
  POST_CO_PILOT_CONFIG_PATH,
  POST_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH,
  POST_ORGANIZATION_PLOT_GROUPS_PATH,
  POST_ORGANIZATION_ROADMAP_NODES_PATH,
  POST_ORGANIZATION_SUMMARY_PATH,
  PostCoPilotConfigErrorDto,
  PostCoPilotConfigRequestBodyData,
  PostCoPilotConfigRequestPathVariables,
  PostCoPilotConfigRequestQueryParams,
  PostCoPilotConfigSuccessDto,
  PostOrganizationPlotGroupComparisonsErrorDto,
  PostOrganizationPlotGroupComparisonsRequestBodyData,
  PostOrganizationPlotGroupComparisonsRequestPathVariables,
  PostOrganizationPlotGroupComparisonsRequestQueryParams,
  PostOrganizationPlotGroupComparisonsSuccessDto,
  PostOrganizationPlotGroupsErrorDto,
  PostOrganizationPlotGroupsRequestBodyData,
  PostOrganizationPlotGroupsRequestPathVariables,
  PostOrganizationPlotGroupsRequestQueryParams,
  PostOrganizationPlotGroupsSuccessDto,
  PostOrganizationRoadmapNodesErrorDto,
  PostOrganizationRoadmapNodesRequestBodyData,
  PostOrganizationRoadmapNodesRequestPathVariables,
  PostOrganizationRoadmapNodesRequestQueryParams,
  PostOrganizationRoadmapNodesSuccessDto,
  PostOrganizationSummaryErrorDto,
  PostOrganizationSummaryRequestBodyData,
  PostOrganizationSummaryRequestPathVariables,
  PostOrganizationSummaryRequestQueryParams,
  PostOrganizationSummarySuccessDto,
} from '@/api/rest/resources/types/organization';

import { useApiDeleteRequest } from '../hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '../hooks/useApiPatchRequest';
import { useApiPostRequest } from '../hooks/useApiPostRequest';

export const usePostPlotGroupComparison = () => {
  return useApiPostRequest<
    PostOrganizationPlotGroupComparisonsRequestPathVariables,
    PostOrganizationPlotGroupComparisonsRequestQueryParams,
    PostOrganizationPlotGroupComparisonsRequestBodyData,
    PostOrganizationPlotGroupComparisonsSuccessDto,
    PostOrganizationPlotGroupComparisonsErrorDto
  >(POST_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH);
};

export const useDeletePlotGroupComparison = () => {
  return useApiDeleteRequest<
    DeleteOrganizationPlotGroupComparisonsRequestPathVariables,
    DeleteOrganizationPlotGroupComparisonsRequestQueryParams,
    DeleteOrganizationPlotGroupComparisonsSuccessDto,
    DeleteOrganizationPlotGroupComparisonsErrorDto
  >(DELETE_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH);
};

export const usePostPlotGroup = () => {
  return useApiPostRequest<
    PostOrganizationPlotGroupsRequestPathVariables,
    PostOrganizationPlotGroupsRequestQueryParams,
    PostOrganizationPlotGroupsRequestBodyData,
    PostOrganizationPlotGroupsSuccessDto,
    PostOrganizationPlotGroupsErrorDto
  >(POST_ORGANIZATION_PLOT_GROUPS_PATH);
};

export const usePatchPlotGroup = () => {
  return useApiPatchRequest<
    PatchOrganizationPlotGroupsRequestPathVariables,
    PatchOrganizationPlotGroupsRequestQueryParams,
    PatchOrganizationPlotGroupsRequestBody,
    PatchOrganizationPlotGroupsSuccessDto,
    PatchOrganizationPlotGroupsErrorDto
  >(PATCH_ORGANIZATION_PLOT_GROUPS_PATH);
};

export const useDeletePlotGroup = () => {
  return useApiDeleteRequest<
    DeleteOrganizationPlotGroupsRequestPathVariables,
    DeleteOrganizationPlotGroupsRequestQueryParams,
    DeleteOrganizationPlotGroupsSuccessDto,
    DeleteOrganizationPlotGroupsErrorDto
  >(DELETE_ORGANIZATION_PLOT_GROUPS_PATH);
};

export const usePatchOrganization = () => {
  return useApiPatchRequest<
    PatchOrganizationRequestPathVariables,
    PatchOrganizationRequestQueryParams,
    PatchOrganizationRequestBodyData,
    PatchOrganizationSuccessDto,
    PatchOrganizationErrorDto
  >(PATCH_ORGANIZATION_PATH);
};

export const usePostOrganizationSummary = () => {
  return useApiPostRequest<
    PostOrganizationSummaryRequestPathVariables,
    PostOrganizationSummaryRequestQueryParams,
    PostOrganizationSummaryRequestBodyData,
    PostOrganizationSummarySuccessDto,
    PostOrganizationSummaryErrorDto
  >(POST_ORGANIZATION_SUMMARY_PATH);
};

export const usePatchOrganizationSummary = () => {
  return useApiPatchRequest<
    PatchOrganizationSummaryRequestPathVariables,
    PatchOrganizationSummaryRequestQueryParams,
    PatchOrganizationSummaryRequestBodyData,
    PatchOrganizationSummarySuccessDto,
    PatchOrganizationSummaryErrorDto
  >(PATCH_ORGANIZATION_SUMMARY_PATH);
};

export const usePostCoPilotConfig = () => {
  return useApiPostRequest<
    PostCoPilotConfigRequestPathVariables,
    PostCoPilotConfigRequestQueryParams,
    PostCoPilotConfigRequestBodyData,
    PostCoPilotConfigSuccessDto,
    PostCoPilotConfigErrorDto
  >(POST_CO_PILOT_CONFIG_PATH);
};

export const usePostRoadmapNode = () => {
  return useApiPostRequest<
    PostOrganizationRoadmapNodesRequestPathVariables,
    PostOrganizationRoadmapNodesRequestQueryParams,
    PostOrganizationRoadmapNodesRequestBodyData,
    PostOrganizationRoadmapNodesSuccessDto,
    PostOrganizationRoadmapNodesErrorDto
  >(POST_ORGANIZATION_ROADMAP_NODES_PATH);
};

export const useDeleteRoadmapNode = () => {
  return useApiDeleteRequest<
    DeleteOrganizationRoadmapNodesRequestPathVariables,
    DeleteOrganizationRoadmapNodesRequestQueryParams,
    DeleteOrganizationRoadmapNodesSuccessDto,
    DeleteOrganizationRoadmapNodesErrorDto
  >(DELETE_ORGANIZATION_ROADMAP_NODES_PATH);
};
